export type Topics = [
  'ricos.toolbars.functionality.buttonClick',
  'ricos.toolbars.instance.loaded',
  'ricos.toolbars.functionality.search'
];

export const topics: Topics = [
  'ricos.toolbars.functionality.buttonClick',
  'ricos.toolbars.instance.loaded',
  'ricos.toolbars.functionality.search',
];
